import React, { useState, useEffect } from 'react'
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import WishListIcon from '../../assets/icons/WishListIcon';
import Badge from '@mui/material/Badge';
import { actionTypes, useStateValue } from "./../../store";
import { getWishListData } from '../../networkCalls';
import WishListIconsm from '../../assets/icons/WishListIconsm';
const WishListCel = ({sizeicon}) => {
    const navigate = useNavigate();

    const [{ token, huid, wishlistitemcount, wishListArrayID }, dispatch] = useStateValue();

    // get wishlist Data form api
    const checkWishListData = () => {
        if (!token) {
            dispatch({ type: actionTypes.SET_WISHLISTCOUNT, value: '0' });
            dispatch({ type: actionTypes.SET_WISHLISTALLID, value: null });
        }
        else {
            var data = new FormData();
            data.append('customerId', huid);
            // data.append('XAuth', token);
            getWishListData(data).then((res) => {
                switch (res.data.status) {
                    case 1:
                        dispatch({ type: actionTypes.SET_WISHLISTCOUNT, value: res?.data?.customerWishlist?.length });
                        dispatch({ type: actionTypes.SET_WISHLISTALLID, value: res?.data?.customerWishlist?.map((item) => item.productId) });
                        return true;
                    case 0:
                        break;
                    case 2:
                        // dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                        break;
                    default:
                        return;
                }
            })
        }
    }

    // eend wishlist api call
    useEffect(() => {
        checkWishListData();
    }, [token, huid, dispatch]);

    const goTOWishListPage = () => {
        if (!token) {
            dispatch({ type: actionTypes.SET_LOGINMODAL, value: true });
        }
        else {
            navigate("/myaccount/manage-wishlist");
        }
    }

    return (
        <>
            <IconButton size={sizeicon} onClick={() => goTOWishListPage()} color="inherit">
                <Badge badgeContent={wishlistitemcount ? wishlistitemcount : '0'} color="error">
                    {sizeicon=='small'?<WishListIconsm />:<WishListIcon />}
                </Badge>
            </IconButton>
        </>
    )
}

export default WishListCel